module.exports = __webpack_public_path__ + "static/media/banner_m_02.cc566b5e.jpg";